const state = {
  // UI主题配置
  uiTheme: null,
  // {
  //     "--theme-color": "#c9915e",
  //     "--theme-color-rgb": "201, 145, 94",
  //     "--button-primary-color": "#c9915e",
  //     "--button-primary-color-hover": "#a0522d",
  //     "--logo-text-color": "#c9915e",
  //     "--menu-item-active": "#c9915e"
  // }

  // 功能模块配置
  feature: null
  // {
  //   ai_video_parsing: 1, // 智能解析
  //   ai_video_subtitles: 1, // 智能字幕
  //   ai_video_moments: 1, // 精彩时刻
  //   ai_video_clip: 1, // 精彩剪辑
  //   ai_video_summary: 1, // 概要总结
  //   ai_video_add2lib: 1 // 添加至音视频
  // }
};

// mutations
const mutations = {
  setUiTheme: (state, obj) => {
    state.uiTheme = obj;
    if (obj) {
      for (const k of Object.keys(obj)) {
        document.documentElement.style.setProperty(k, obj[k]);
      }
    }
  },
  setFeature: (state, obj) => {
    state.feature = obj;
  }
};

export default {
  namespaced: true,
  state,
  mutations
};
